import React, { useState } from 'react';
import { FaEnvelope, FaWhatsapp, FaGithub, FaLinkedin, FaMapMarkerAlt } from 'react-icons/fa';
import { submitContact } from '../services/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await submitContact(formData);
      toast.success('Message sent successfully! I\'ll get back to you soon.');
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    } catch (error) {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      label: 'Email',
      value: 'sangaben07@gmail.com',
      link: 'mailto:sangaben07@gmail.com'
    },
    {
      icon: <FaWhatsapp />,
      label: 'WhatsApp',
      value: '+256 766 670 007',
      link: 'https://wa.me/256766670007'
    },
    {
      icon: <FaGithub />,
      label: 'GitHub',
      value: 'github.com/sangaben',
      link: 'https://github.com/sangaben'
    },
    {
      icon: <FaLinkedin />,
      label: 'LinkedIn',
      value: 'Ben Sanga',
      link: 'https://www.linkedin.com/in/ben-sanga-a9b2032b1/'
    },
    {
      icon: <FaMapMarkerAlt />,
      label: 'Location',
      value: 'Uganda',
      link: null
    }
  ];

  return (
    <div className="contact-page">
      <ToastContainer position="top-right" autoClose={5000} />
      
      <div className="page-header">
        <h1>Get In Touch</h1>
        <p>Let's discuss your next project or collaboration</p>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <h2>Contact Information</h2>
          <p>I'm currently available for projects and collaborations. Whether you need a website, design work, or hosting solutions, let's discuss how I can help.</p>
          
          <div className="info-grid">
            {contactInfo.map((item, index) => (
              <div key={index} className="info-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="info-icon">{item.icon}</div>
                <div className="info-details">
                  <h3>{item.label}</h3>
                  {item.link ? (
                    <a href={item.link} target="_blank" rel="noopener noreferrer">
                      {item.value}
                    </a>
                  ) : (
                    <p>{item.value}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="contact-form">
          <h2>Send Me a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Your Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Your Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Your Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                className="form-control"
              ></textarea>
            </div>

            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;